import { defineComponent as _defineComponent } from 'vue'
import { type PropType, useRoute, useStore } from "@nuxtjs/composition-api";

import { useAmplitude } from "@/composables";
import { getAmplitudeStore } from "@/store/amplitude";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkDetailHeader',
  props: {
  mainText: {
    type: String,
    required: true,
  },
  displayName: {
    type: String,
    required: true,
  },
  profileId: {
    type: String,
    required: true,
  },
  pageTitle: {
    type: String,
    default: "",
  },
  eventProperties: {
    type: Object as PropType<{ [key: string]: string | boolean } | undefined>,
    required: false,
    default: undefined,
  },
},
  setup(__props) {



const store = useStore();
const amplitude = useAmplitude();
const route = useRoute();

const onLinkClick = () => {
  const refComponent = amplitude?.getReferringComponentByPage(route.value.name ?? "");
  if (refComponent) {
    getAmplitudeStore(store).setReferringComponent(refComponent);
  }
};

return { __sfc: true,store, amplitude, route, onLinkClick }
}

})